<script setup>
const isConfigOpen = defineModel('isConfigOpen', Boolean)
const baseMapType = defineModel('baseMapType', String)
const bgOpacity = defineModel('bgOpacity', Number)
const echoOpacity = defineModel('echoOpacity', Number)

const onClickClose = () => {
  isConfigOpen.value = false
}
</script>
<template>
  <MiOOverlay
    data-color="clear"
    :data-showed="isConfigOpen"
    @click.self="onClickClose()"
  >
    <MiMOverlayBlock data-position="left">
      <div>
        <MiAMapItem data-content="map">
          <template #title>
            地図選択
          </template>
          <template #content>
            <ClientOnly>
              <div
                :data-selected="baseMapType === 'osm-basic'"
                @click="baseMapType = 'osm-basic'"
              >
                <figure>
                  <img
                    src="https://gvs.weathernews.jp/onebox/radar/img/icon/image_map_normal.jpg"
                    width="28"
                    height="28"
                    loading="lazy"
                    alt=""
                  >
                </figure>
                <p>標準</p>
              </div>
              <div
                :data-selected="baseMapType === 'gsi-photo'"
                @click="baseMapType = 'gsi-photo'"
              >
                <figure>
                  <img
                    src="https://gvs.weathernews.jp/onebox/radar/img/icon/image_map_satellite.jpg"
                    width="28"
                    height="28"
                    loading="lazy"
                    alt=""
                  >
                </figure>
                <p>衛星</p>
              </div>
            </ClientOnly>
          </template>
        </MiAMapItem>
        <MiAMapItem data-content="range">
          <template #title>
            背景色調整
          </template>
          <template #content>
            <input
              id="inputBackGround"
              v-model.number="bgOpacity"
              type="range"
              name="bg_bright"
              min="0"
              max="0.7"
              step="0.1"
              :style="{background: `linear-gradient(90deg, #3569c0 ${(bgOpacity / 0.7) * 100}%, #9fa9b3 ${((0.7 - bgOpacity) / 0.7) * 100}%)`}"
            >
            <div>
              <p>明るい</p>
              <p>暗い</p>
            </div>
          </template>
        </MiAMapItem>
        <MiAMapItem data-content="range">
          <template #title>
            黄砂の色調整
          </template>
          <template #content>
            <input
              id="inputEchoColor"
              v-model.number="echoOpacity"
              type="range"
              name="echo_bright"
              min="0.1"
              max="1.0"
              step="0.1"
              :style="{background: `linear-gradient(90deg, #3569c0 ${((echoOpacity - 0.1) / 0.9) * 100}%, #9fa9b3 ${((0.9 - (echoOpacity - 0.1)) / 0.9) * 100}%)`}"
            >
            <div>
              <p>明るい</p>
              <p>暗い</p>
            </div>
          </template>
        </MiAMapItem>
      </div>
      <MiACloseButton data-type="circle">
        <button @click="onClickClose()" />
      </MiACloseButton>
    </MiMOverlayBlock>
  </MiOOverlay>
</template>

<style lang="scss" scoped>
</style>
